import { render, staticRenderFns } from "./ServiceConfigAdminList.vue?vue&type=template&id=09a4aa48&"
import script from "./ServiceConfigAdminList.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports